// Header mobile toggle + close on nav-link click
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.header-mobile-toggle');
  const mobileNav = document.querySelector('.header-mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      const open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      });
    });
  }
});

// FAQ Accordion
document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const header = item.querySelector('.faq-item-header');
    if (!header) return;
    header.addEventListener('click', function () {
      const isOpen = item.classList.contains('open');
      // Close all
      faqItems.forEach(function (i) {
        i.classList.remove('open');
        i.classList.add('closed');
        const toggle = i.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '+';
      });
      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('open');
        item.classList.remove('closed');
        const toggle = item.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '−';
      }
    });
  });

  // Contact form submit
  const form = document.querySelector('.contact-form form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.btn-send');
      btn.textContent = 'Sent! ✓';
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = 'Send Message';
        btn.disabled = false;
        form.reset();
      }, 3000);
    });
  }

  // Testimonials carousel arrows
  // Mobile (slider): scroll horizontally by one card width.
  // Desktop (no horizontal scroll): rotate the card order.
  const tGrid = document.querySelector('.testimonials-grid');
  document.querySelectorAll('.testimonial-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!tGrid || tGrid.children.length < 2) return;
      const dir = btn.getAttribute('data-dir');
      const isSlider = tGrid.scrollWidth > tGrid.clientWidth + 4;
      if (isSlider) {
        const card = tGrid.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + 16 : tGrid.clientWidth * 0.8;
        tGrid.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
      } else {
        if (dir === 'next') {
          tGrid.appendChild(tGrid.firstElementChild);
        } else {
          tGrid.insertBefore(tGrid.lastElementChild, tGrid.firstElementChild);
        }
      }
    });
  });
});
